var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M32 10.1318C42.4434 10.1318 49.3812 15.3902 51.9208 17.6954C52.6434 18.3513 53.0075 19.2949 52.9744 20.2702C52.5718 32.1356 47.3445 45.2505 32 53.8817","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M32 10.1318C21.5566 10.1318 14.6188 15.3902 12.0792 17.6954C11.3566 18.3513 10.9925 19.2949 11.0256 20.2702C11.4282 32.1356 16.6555 45.2505 32 53.8817","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M32 15.8662L32 45.1471","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"3 3","key":2})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 64 65"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
